// extracted by mini-css-extract-plugin
export default {"quillWrapper":"ReactQuillEditor_quillWrapper__CMncw"};